const CONTRACT = 'artwork_count_v1';
const money = (cents) => `$${(cents / 100).toFixed(2).replace('.00', '')}`;
const totals = (count) => {
  const full = count === 1 ? 3900 : count === 2 ? 6900 : count >= 3 ? 8900 + (count - 3) * 2900 : 0;
  const paid = count * 1000;
  return { count, full, paid, balance: Math.max(0, full - paid), savings: Math.max(0, count * 3900 - full) };
};
const eligible = (item) => {
  const properties = item.properties || {};
  return item.final_price === 1000 && (properties['_Pricing contract'] === CONTRACT || ['US$10 portrait start', 'US$10 Pet & Human portrait start'].includes(properties['_Order Journey']));
};
const orderPricingLabel = ({ count, full, paid, balance, savings }) => `${count} artwork${count === 1 ? '' : 's'} · ${money(full)} full · ${money(paid)} today · ${money(balance)} after approval · save ${money(savings)}`;
let running = false;
let checkoutSyncing = false;
async function syncPricing() {
  if (running) return;
  running = true;
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    const calculated = totals(cart.items.filter(eligible).reduce((sum, item) => sum + item.quantity, 0));
    const values = { count: String(calculated.count), full: money(calculated.full), paid: money(calculated.paid), balance: money(calculated.balance), savings: money(calculated.savings), regular: money(calculated.count * 3900) };
    Object.entries(values).forEach(([key, value]) => document.querySelectorAll(`[data-unified-${key}]`).forEach((node) => { node.textContent = value; }));
    document.querySelectorAll('[data-unified-count-label]').forEach((node) => { node.textContent = `${calculated.count} artwork${calculated.count === 1 ? '' : 's'} × $39`; });
    document.querySelectorAll('[data-unified-discount], [data-unified-regular]').forEach((node) => node.toggleAttribute('hidden', calculated.count <= 1));
    const desired = {
      '_Pricing contract': CONTRACT,
      '_Artwork count': values.count,
      '_Full order amount': values.full,
      '_Start paid today': values.paid,
      '_Balance after approval': values.balance,
      '_Artwork savings': values.savings,
    };
    if (Object.entries(desired).some(([key, value]) => String(cart.attributes?.[key] || '') !== value)) {
      await fetch('/cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: desired }) });
    }
  } catch (error) {
    console.warn('[pawty-unified-pricing]', error);
  } finally { running = false; }
}
async function syncCheckoutProperties(event) {
  const checkoutButton = event.target?.closest?.('[name="checkout"], [data-pawty-dynamic-checkout]');
  if (!checkoutButton || checkoutSyncing) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  checkoutSyncing = true;
  checkoutButton.disabled = true;
  checkoutButton.setAttribute('aria-busy', 'true');
  try {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    const eligibleItems = cart.items.filter(eligible);
    const calculated = totals(eligibleItems.reduce((sum, item) => sum + item.quantity, 0));
    const label = orderPricingLabel(calculated);
    for (const item of eligibleItems) {
      if (item.properties?.['Order pricing'] === label) continue;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { ...(item.properties || {}), 'Order pricing': label } }),
      });
      if (!response.ok) throw new Error(`Checkout pricing sync failed: ${response.status}`);
    }
    window.location.assign('/checkout');
  } catch (error) {
    console.warn('[pawty-unified-checkout]', error);
    checkoutButton.disabled = false;
    checkoutButton.removeAttribute('aria-busy');
    checkoutSyncing = false;
  }
}
syncPricing();
document.addEventListener('cart:update', syncPricing);
document.addEventListener('click', syncCheckoutProperties, true);
new MutationObserver(() => window.requestAnimationFrame(syncPricing)).observe(document.documentElement, { childList: true, subtree: true });
